export default [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/home/Home.vue'),
    meta: {
      pageTitle: 'Dashboard',
      breadcrumb: [
        {
          text: 'Dashboard',
          active: true,
        },
      ],
      requireAuth: true,
    },
  },
]
